import {createApp, h, defineAsyncComponent} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import VueCookies from 'vue-cookies';
import router from '@/router';

const TsdIdentModal = defineAsyncComponent(() => import('@/features/tsd/ident/TsdIdentModal.vue'));

/**
 *  Imperative entrypoint for legacy jQuery pages whose request was rejected with 403
 *  "tsd-ident-required" (payout delete that has to cancel lines at EMTA). Runs the plain eID
 *  identification in a one-shot Vue app; resolves with the verified personal code (the server
 *  has already stored it on the company user, so the caller just retries its request), or null
 *  when the user closes the modal.
 */
export function openTsdIdent(
    companyId: number | string,
    translations: Record<string, string>
): Promise<string | null> {
    return new Promise((resolve) => {
        const container = document.createElement('div');
        document.body.appendChild(container);

        let settled = false;
        const settle = (personalCode: string | null) => {
            if (settled) return;
            settled = true;
            try { app.unmount(); } catch { /* nothing to clean up */ }
            container.remove();
            resolve(personalCode);
        };

        const app = createApp({
            name: 'TsdIdentHost',
            render() {
                return h(TsdIdentModal, {
                    translations,
                    companyId: Number(companyId),
                    onIdentified: (personalCode: string) => settle(personalCode),
                    onClose: () => settle(null),
                });
            }
        });

        const pinia = createPinia();
        pinia.use(piniaPluginPersistedstate);
        app.use(pinia);
        app.use(router);
        app.use(VueCookies);
        app.mount(container);
    });
}
